<template>
  <b-container>
    <b-row>
      <b-col lg="6">
        <b-card>
          <b-form @submit.prevent="handleSubmit()">
            <h3>Editar información de tienda</h3>

            <b-tabs>
              <b-tab title="Información de la tienda">
                <div class="d-flex justify-content-start my-2">
                  <base-cropper
                    :model="store"
                    @cropped-image="store.logo = $event"
                  />
                </div>

                <b-form-group class="mb-2" label="Nombre de la tienda">
                  <b-form-input v-model="store.name" required />
                </b-form-group>

                <b-form-group
                  class="mb-2"
                  label="¿Vendes en linea o en tu tienda fisica?"
                >
                  <b-form-select
                    v-model="store.category"
                    :options="storeCategory"
                  />
                </b-form-group>

                <b-form-group
                  v-if="store.store_type !== 'supplier_type'"
                  class="mb-2"
                  label="Tipo de tienda"
                >
                  <b-form-select
                    v-model="store.store_type"
                    :options="storeType"
                  />
                </b-form-group>

                <b-form-group class="mb-2" label="¿A qué hora abres la tienda?">
                  <v-select
                    v-model="store.start_of_day_restocking_time"
                    :options="timeArray"
                    :reduce="(val) => val.type"
                    label="name"
                    clearable
                    placeholder="Selecciona el mejor horario para ti"
                  />
                </b-form-group>

                <b-form-group
                  class="mb-2"
                  label="¿A qué hora cierras la tienda?"
                >
                  <v-select
                    v-model="store.end_of_day_restocking_time"
                    :options="timeArray"
                    :reduce="(val) => val.type"
                    label="name"
                    clearable
                    placeholder="Selecciona el mejor horario para ti"
                  />
                </b-form-group>

                <b-form-group
                  class="mb-2"
                  label="Mensaje de cobro para ventas en linea"
                >
                  <b-form-input v-model="store.codi_message" required />
                </b-form-group>

                <b-form-group
                  class="mb-50"
                  label="¿Deseas participar en un Marketplace general?"
                >
                  <b-form-checkbox
                    id="in_marketplace"
                    v-model="store.in_marketplace"
                    class="custom-control-primary"
                    name="check-button"
                    switch
                  >
                    {{ store.in_marketplace ? "Sí" : "No" }}
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  class="mb-50"
                  label="Selecciona los datos de compra que deseas solicitar a tus clientes"
                >
                  <b-form-checkbox
                    id="purchase_name"
                    v-model="purchaseInfo.name"
                    class="custom-control-primary"
                    name="check-button"
                  >
                    Nombre
                  </b-form-checkbox>
                  <b-form-checkbox
                    id="purchase_email"
                    v-model="purchaseInfo.email"
                    class="custom-control-primary"
                    name="check-button"
                  >
                    Email
                  </b-form-checkbox>
                  <b-form-checkbox
                    id="purchase_phone"
                    v-model="purchaseInfo.phone"
                    class="custom-control-primary"
                    name="check-button"
                  >
                    Teléfono
                  </b-form-checkbox>
                  <b-form-checkbox
                    id="purchase_delivery_date"
                    v-model="purchaseInfo.delivery_date"
                    class="custom-control-primary"
                    name="check-button"
                  >
                    Fecha de entrega
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  label="Selecciona los tipos de pago que acepta esta tienda para ventas en linea"
                  label-for="is-edible"
                >
                  <b-form-checkbox
                    id="cash"
                    v-model="acceptedPaymentTypes"
                    class="custom-control-primary"
                    name="check-button"
                    value="cash"
                    switch
                    @change="validatePaymentTypes"
                  >
                    Efectivo
                  </b-form-checkbox>
                  <b-form-checkbox
                    id="walleat"
                    v-model="acceptedPaymentTypes"
                    class="custom-control-primary"
                    name="check-button"
                    value="walleat"
                    switch
                    @change="validatePaymentTypes"
                  >
                    Walleat Pay
                  </b-form-checkbox>
                  <b-form-checkbox
                    id="bankcard"
                    v-model="acceptedPaymentTypes"
                    class="custom-control-primary"
                    name="check-button"
                    value="bankcard"
                    switch
                    @change="validatePaymentTypes"
                  >
                    Tarjeta bancaria
                  </b-form-checkbox>
                  <b-form-checkbox
                    id="reward_points"
                    v-model="acceptedPaymentTypes"
                    class="custom-control-primary"
                    name="check-button"
                    value="reward_points"
                    switch
                    @change="validatePaymentTypes"
                  >
                    Puntos de recompensa
                  </b-form-checkbox>
                  <b-form-checkbox
                    id="bank_deposit"
                    v-model="acceptedPaymentTypes"
                    class="custom-control-primary"
                    name="check-button"
                    value="bank_deposit"
                    switch
                    @change="validatePaymentTypes"
                  >
                    Transferencia o depósito bancario
                  </b-form-checkbox>
                  <b-form-checkbox
                    id="codi"
                    v-model="acceptedPaymentTypes"
                    class="custom-control-primary d-flex"
                    name="check-button"
                    value="codi"
                    switch
                    @change="validatePaymentTypes"
                  >
                    CoDi
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  label="Selecciona la terminal de pago que acepta esta tienda"
                  label-for="terminal_type"
                  v-if="acceptedPaymentTypes.includes('bankcard')"
                >
                  <b-form-radio
                    id="no_terminal"
                    v-model="store.terminal_type"
                    class="custom-control-primary"
                    name="check-button"
                    value="no_terminal"
                  >
                    No acepta terminal
                  </b-form-radio>
                  <b-form-radio
                    id="netpay"
                    v-model="store.terminal_type"
                    class="custom-control-primary"
                    name="check-button"
                    value="netpay"
                  >
                    NetPay
                  </b-form-radio>
                  <b-form-radio
                    id="other_terminal"
                    v-model="store.terminal_type"
                    class="custom-control-primary"
                    name="check-button"
                    value="other_terminal"
                  >
                    Otra terminal
                  </b-form-radio>
                </b-form-group>

                <h4 class="mt-2">Dirección de la tienda</h4>

                <div>
                  <google-map-form
                    :latitude="latitude ? Number(latitude) : null"
                    :longitude="longitude ? Number(longitude) : null"
                    :zoom="latitude && longitude ? 10 : 4"
                    :default-address="
                      store.address_attributes
                        ? store.address_attributes.formatted_address
                        : ''
                    "
                    @getAddress="setAddress($event)"
                  />
                </div>
              </b-tab>
              <b-tab title="Detalles de envio" active>
                <div>
                  <b-form-group
                    label="Selecciona los metodos de envio que acepta esta tienda"
                    label-for="is-edible"
                  >
                    <v-select
                      v-model="store.delivery_option"
                      :options="deliveryOptions"
                      :reduce="(val) => val.value"
                      label="text"
                      clearable
                      placeholder="Selecciona el tipo de envio"
                    />
                  </b-form-group>

                  <b-form-group
                    label="Selecciona el tipo de envio"
                    label-for="is-edible"
                    v-if="
                      store.delivery_option === 'delivery' ||
                      store.delivery_option === 'both'
                    "
                  >
                    <b-form-radio-group
                      id="delivery-type"
                      stacked
                      v-model="store.delivery_type"
                      class="custom-control-primary mb-50"
                      :options="deliveryTypes"
                      name="delivery-type"
                    />
                  </b-form-group>

                  <div
                    class="mt-2"
                    v-if="
                      (store.delivery_option === 'delivery' ||
                        store.delivery_option === 'both') &&
                      store.delivery_type === 'local'
                    "
                  >
                    <div class="d-flex align-items-center mb-2">
                      <h4 class="mb-0">Zonas de envio</h4>
                      <feather-icon
                        id="delivery-zones-help"
                        icon="HelpCircleIcon"
                        class="ml-50 cursor-pointer"
                        size="16"
                        @click="startDeliveryZonesTour"
                      />
                    </div>

                    <delivery-zones-drawer
                      :latitude="latitude ? Number(latitude) : null"
                      :longitude="longitude ? Number(longitude) : null"
                      :default-zones="store.delivery_zones"
                      zoneListId="zone-list"
                      gmapId="delivery-zones-map"
                      class="v-step-5"
                      @zones="deliveryZones = $event"
                    />

                    <v-tour
                      name="delivery-zones"
                      :steps="deliveryZonesSteps"
                      :options="tourOptions"
                    ></v-tour>
                  </div>
                </div>
              </b-tab>
            </b-tabs>

            <div class="mt-2 d-flex justify-content-between">
              <b-button
                variant="outline-secondary"
                :to="{
                  name: 'establishment-sucursales',
                  params: { id: establishmentId },
                }"
                size="lg"
              >
                Cancelar
              </b-button>
              <b-button variant="primary" size="lg" type="submit">
                Guardar
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col>
        <div class="text-center">
          <b-img
            :src="
              require('@/assets/images/illustration/pricing-Illustration.svg')
            "
            width="600"
            fluid
          />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// Directives
import { mapActions } from "vuex"
import vSelect from "vue-select"

// Components
import BaseCropper from "@/@core/components/BaseCropper.vue"
import PolygonDrawer from "@/@core/components/polygon-drawer.vue"
import GoogleMapForm from "@/@core/components/google-map-form.vue"
import DeliveryZonesDrawer from "@/@core/components/delivery-zones-drawer.vue"

// Mixins
import messagesMixin from "@/@core/mixins/messagesMixin"

// Utils
import { generateTimeArray } from "@/@core/utils/time-utils"
import { deliveryOptions, deliveryTypes } from "@/@core/utils/delivery-utils"
import { STORE_TYPES } from "../../constants/store"

export default {
  components: {
    vSelect,
    GoogleMapForm,
    BaseCropper,
    PolygonDrawer,
    DeliveryZonesDrawer,
  },
  mixins: [messagesMixin],
  data() {
    return {
      establishmentId: this.$route.params.id,
      acceptedPaymentTypes: [],
      timeArray: [],
      store: {
        establishment_id: this.establishmentId,
        name: null,
        logo: null,
        category: null,
        store_type: null,
        codi_message: null,
        accepted_payment_types: [],
        address_attributes: null,
        end_of_day_restocking_time: null,
        start_of_day_restocking_time: null,
        delivery_option: null,
        delivery_radius: null,
        delivery_type: null,
        terminal_type: null,
        in_marketplace: false,
        delivery_zones: [],
      },
      deliveryZones: [],
      purchaseInfo: {
        name: false,
        email: false,
        phone: false,
        delivery_date: false,
      },
      userData: JSON.parse(localStorage.getItem("userData")),
      componentRestrictions: { country: "mx" },
      initialStore: {},

      deliveryZonesSteps: [
        {
          target: "#delivery-zones-help",
          content:
            "Bienvenido al tutorial de Zonas de Envío. Aquí aprenderás cómo configurar las áreas donde tu tienda realiza entregas.",
          params: {
            placement: "bottom",
          },
        },
        {
          target: "#delivery-zones-map",
          content:
            "Este mapa te permite definir las zonas geográficas donde realizas entregas.",
          params: {
            placement: "top",
          },
        },
        {
          target: "#add-zone",
          content:
            'Para empezar a seleccionar zonas, haga click en el botón "Agregar Zona".',
          params: {
            placement: "left",
          },
        },
        {
          target: "#delivery-zones-map",
          content:
            "Selecciona distintos puntos en el mapa para representar la zona de envío.",
          params: {
            placement: "left",
          },
        },
        {
          target: "#zone-list",
          content:
            "Aquí verás la lista de zonas que has creado. Puedes editar o eliminar cada zona según sea necesario.",
          params: {
            placement: "top",
          },
        },
        {
          target: "#zone-list",
          content:
            "Para editar una zona haz click en la zona y podras editar los puntos y el nombre.",
          params: {
            placement: "bottom",
          },
        },
      ],
  
      tourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Saltar",
          buttonPrevious: "Anterior",
          buttonNext: "Siguiente",
          buttonStop: "Finalizar",
        },
      },
      deliveryOptions: deliveryOptions(),
      deliveryTypes: deliveryTypes(),
      storeCategory: [
        { value: "physical", text: "Tienda fisica" },
        { value: "online", text: "Tienda en línea" },
        { value: "hybrid", text: "Tienda híbrida" },
      ],
      storeType: STORE_TYPES,
      center: { lat: 19.4326077, lng: -99.133208 },
      zoom: 4,
      width: "100%",
      height: "500px",
      marker: {},
      circle: {
        center: null,
        radius: 1000,
      },
      latitude: null,
      longitude: null,
      circleRadiusKm: 0,
      addressId: null,
    }
  },
  computed: {
    showDeliveryRadius() {
      return (
        (this.store.delivery_option === "delivery" ||
          this.store.delivery_option === "both") &&
        this.store.delivery_type === "local" &&
        this.store.address_attributes
      )
    },
  },
  mounted() {
    if (this.$route.params.store_id) {
      this.fetchStore(this.$route.params.store_id).then((response) => {
        this.store = structuredClone(response)
        this.initialStore = structuredClone(response)

        this.purchaseInfo = {
          name: response.purchase_info?.name,
          email: response.purchase_info?.email,
          phone: response.purchase_info?.phone,
          delivery_date: response.purchase_info?.delivery_date,
        }

        this.latitude = response.address_attributes?.lat
        this.longitude = response.address_attributes?.lng
        this.addressId = response.address_attributes?.id

        this.acceptedPaymentTypes = this.store.accepted_payment_types
        this.formatTimes()
      })
    }

    this.timeArray = generateTimeArray()
  },
  methods: {
    ...mapActions("stores", ["editStore", "fetchStore"]),

    startDeliveryZonesTour() {
      this.$tours["delivery-zones"].start()
    },
    setAddress(place) {
      this.store.address_attributes = place
    },

    validatePaymentTypes() {
      if (this.store.store_type === "supplier_type") {
        this.acceptedPaymentTypes = ["cash"]
        this.showErrorToast(
          "Error",
          "Si deseas agregar más metodos de pago, contactanos en Whatsapp 55 2939 7947"
        )
      }
    },

    formatTimes() {
      if (this.store.end_of_day_restocking_time) {
        // Extract hours and minutes from the string
        const hoursAndMinutes = this.store.end_of_day_restocking_time.slice(
          11,
          19
        )
        this.store.end_of_day_restocking_time = hoursAndMinutes
        this.initialStore.end_of_day_restocking_time = hoursAndMinutes
      }

      if (this.store.start_of_day_restocking_time) {
        // Extract hours and minutes from the string
        const hoursAndMinutes = this.store.start_of_day_restocking_time.slice(
          11,
          19
        )
        this.store.start_of_day_restocking_time = hoursAndMinutes
        this.initialStore.start_of_day_restocking_time = hoursAndMinutes
      }
    },
    setStore() {
      const address = this.store.address_attributes

      address.id = this.addressId

      console.log(this.store.delivery_zones, this.deliveryZones)

      return {
        name: this.store.name,
        establishment_id: this.establishmentId,
        logo: this.store.logo,
        category: this.store.category,
        store_type: this.store.store_type,
        address_attributes: address,
        codi_message: this.store.codi_message,
        accepted_payment_types: this.acceptedPaymentTypes,
        end_of_day_restocking_time: this.store.end_of_day_restocking_time,
        start_of_day_restocking_time: this.store.start_of_day_restocking_time,
        delivery_option: this.store.delivery_option,
        delivery_radius: this.circle.radius,
        delivery_type: this.store.delivery_type,
        terminal_type: this.store.terminal_type,
        in_marketplace: this.store.in_marketplace,
        purchase_info: this.purchaseInfo,
        delivery_zones: this.deliveryZones.map((zone) => {
          return {
            id: zone.id,
            name: zone.name,
            coordinates: zone.coordinates,
          }
        }),
      }
    },

    isEqual(initialStore, newStore) {
      if (
        initialStore.name === newStore.name &&
        initialStore.logo === newStore.logo &&
        initialStore.category === newStore.category &&
        initialStore.store_type === newStore.store_type &&
        initialStore.address_attributes === newStore.address_attributes &&
        initialStore.codi_message === newStore.codi_message &&
        initialStore.accepted_payment_types ===
          newStore.accepted_payment_types &&
        initialStore.end_of_day_restocking_time ===
          newStore.end_of_day_restocking_time &&
        initialStore.start_of_day_restocking_time ===
          newStore.start_of_day_restocking_time &&
        initialStore.delivery_option === newStore.delivery_option &&
        initialStore.delivery_radius === newStore.delivery_radius &&
        initialStore.delivery_type === newStore.delivery_type
      ) {
        return true
      }

      return false
    },

    handleSubmit() {
      if (
        !this.store.address_attributes ||
        !this.store.address_attributes.lat ||
        !this.store.address_attributes.lng
      ) {
        this.showErrorToast(
          "Error",
          "Por favor selecciona una dirección en el mapa"
        )

        return
      }

      let store = this.setStore()

      // if (this.isEqual(this.initialStore, store)) {
      //   this.showSuccessToast("Exito", "No se realizaron cambios")

      //   return
      // }

      this.$swal({
        title: "¿Estas seguro de que deseas guardar los cambios?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, guardar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger mr-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            title: "Guardando cambios...",
            didOpen: () => {
              this.$swal.showLoading()
            },
            showConfirmButton: false,
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
          })

          console.log("hola")

          this.editStore({ id: this.$route.params.store_id, store })
            .then((res) => {
              this.showSuccessToast("Tienda editada correctamente")

              if (this.userData.role_name === "establishment_supplier") {
                this.$router.push({
                  name: "establishment-view",
                  params: { id: this.userData.supplier_info?.establishment_id },
                })
                return
              }

              this.$router.push({
                name: "establishment-sucursales",
                params: { id: this.establishmentId },
              })
            })
            .catch((error) => {
              console.log(error)
              console.log(error.response)
              this.handleFetchError(
                error.response.data,
                "Error al editar la tienda"
              )
            })
            .finally(() => {
              this.$swal.close()
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
.v-step {
  z-index: 1000;
  background: #fff;
  color: #2c3e50;
  border-radius: 5px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 15px;
  max-width: 320px;
}

.cursor-pointer {
  cursor: pointer;
}
.custom-control {
  margin-bottom: 0.5rem;
}

.radius__button {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 0;
}

.pac-target-input {
  color: #495057;
  background-color: #fff;
  border: 1px solid #404656;

  padding: 0.438rem 1rem;
  border-radius: 0.357rem;
  width: 100%;
}

.dark-layout {
  .pac-target-input {
    color: #b4b7bd;
    background-color: #283046;
    border: 1px solid #404656;
  }
}
</style>
